import React, {CSSProperties, useCallback} from 'react';
import classnames from 'classnames';

import styles from './styles.scss';
import {useHistory} from 'react-router';

type Props = {
    children?:any;
    color?:'pink'|'light-pink'|'blue'|'light-blue'|'light-yellow'|'grey'|'white-pink'|'white-graphite';
    link?:string;
    navLink?:string;
    disabled?:boolean;
    open?:string;
    className?:string;
    onClick?:Function;
    style?:CSSProperties;
};

export const Button = (props:Props) => {
    const {style, children, color = 'pink', disabled = false} = props;
    
    const history = useHistory();
    const navLinkClick = useCallback(() => history.push(props.navLink), [history]);

    const onClick = () => {

        if(disabled){
            return null;
        }

        if(props.open){
            window.open(props.open);
        }

        if(props.link){
            location.href = props.link;
        }
        
        if(props.navLink){
            navLinkClick();
        }

        if(typeof props.onClick == 'function'){
            props.onClick();
        }
        
        return null;
    };
    
    return <div className={classnames(styles.button, styles[color], props.className, disabled && styles.disabled)} style={{...style}} onClick={onClick}>{children}</div>;
};

